import { render } from "./StatusLabel.vue?vue&type=template&id=ca0296d4&ts=true"
import script from "./StatusLabel.vue?vue&type=script&lang=ts"
export * from "./StatusLabel.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__